/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:client-pilet:file-viewer */

export interface FileViewerBlockParams {}
/** Block parameters for urn:block:client-pilet:settings-page */

export interface SettingsPageBlockParams {}
/** Block parameters for urn:block:client-pilet:client-tools */

export interface ClientToolsBlockParams {}
/** Block parameters for urn:block:client-pilet:mac-tools */

export interface MacToolsBlockParams {}
/** Block parameters for urn:block:client-pilet:windows-tools */

export interface WindowsToolsBlockParams {}
/** Block parameters for urn:block:client-pilet:mobile-tools */

export interface MobileToolsBlockParams {}
/** Block parameters for urn:block:client-pilet:recent-files */

export interface RecentFilesBlockParams {}
/** Block parameters for urn:block:client-pilet:favorites */

export interface FavoritesBlockParams {}

export namespace BlockNames {
	export const FileViewer = 'urn:block:client-pilet:file-viewer' as const;
	export type FileViewer = 'urn:block:client-pilet:file-viewer';
	export const SettingsPage = 'urn:block:client-pilet:settings-page' as const;
	export type SettingsPage = 'urn:block:client-pilet:settings-page';
	export const ClientTools = 'urn:block:client-pilet:client-tools' as const;
	export type ClientTools = 'urn:block:client-pilet:client-tools';
	export const MacTools = 'urn:block:client-pilet:mac-tools' as const;
	export type MacTools = 'urn:block:client-pilet:mac-tools';
	export const WindowsTools = 'urn:block:client-pilet:windows-tools' as const;
	export type WindowsTools = 'urn:block:client-pilet:windows-tools';
	export const MobileTools = 'urn:block:client-pilet:mobile-tools' as const;
	export type MobileTools = 'urn:block:client-pilet:mobile-tools';
	export const RecentFiles = 'urn:block:client-pilet:recent-files' as const;
	export type RecentFiles = 'urn:block:client-pilet:recent-files';
	export const Favorites = 'urn:block:client-pilet:favorites' as const;
	export type Favorites = 'urn:block:client-pilet:favorites';
}

export namespace ZoneTypes {}

export type FileViewerProps = ShellProps & BlockParams & FileViewerBlockParams;
export type SettingsPageProps = ShellProps & BlockParams & SettingsPageBlockParams;
export type ClientToolsProps = ShellProps & BlockParams & ClientToolsBlockParams;
export type MacToolsProps = ShellProps & BlockParams & MacToolsBlockParams;
export type WindowsToolsProps = ShellProps & BlockParams & WindowsToolsBlockParams;
export type MobileToolsProps = ShellProps & BlockParams & MobileToolsBlockParams;
export type RecentFilesProps = ShellProps & BlockParams & RecentFilesBlockParams;
export type FavoritesProps = ShellProps & BlockParams & FavoritesBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:client-pilet:file-viewer']: BlockParams & FileViewerBlockParams;
		['urn:block:client-pilet:settings-page']: BlockParams & SettingsPageBlockParams;
		['urn:block:client-pilet:client-tools']: BlockParams & ClientToolsBlockParams;
		['urn:block:client-pilet:mac-tools']: BlockParams & MacToolsBlockParams;
		['urn:block:client-pilet:windows-tools']: BlockParams & WindowsToolsBlockParams;
		['urn:block:client-pilet:mobile-tools']: BlockParams & MobileToolsBlockParams;
		['urn:block:client-pilet:recent-files']: BlockParams & RecentFilesBlockParams;
		['urn:block:client-pilet:favorites']: BlockParams & FavoritesBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {}

	interface ViewEngineCustomZoneContractDataMap {}
}
